import React, { useRef, useState } from "react";
import { Dialog } from 'primereact/dialog';
import GenericTableView from "../../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../../enum/TableView";
import { GenericTableColumns } from "../../../models/GenericTableViewModel";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';
import { RouteComponentProps } from "../../../models/RouteComponent";
import { useNavigate } from "react-router-dom";
import EmployeeSiteAdd from "./Employee-Site-Add";
import {siteEmployeeRemove, siteEmployeeUpdate} from "../../../service/siteService";

export default function EmployeeSiteTable(props: RouteComponentProps) {

  const navigate = useNavigate();

  const [selectedRecord, setSelectedRecord] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);

  const toast = useRef(null as any);

  let url = 'employee-site';

  const baseFilter = {
    'name': { value: '', matchMode: FilterMatchMode.CONTAINS },
  }

  const addButton = (row: any) => {
    console.log("addButton row == ", row)
    setSelectedRecord(null);
    setVisible(true);
  }

  const itemSelected = (row: any) => {
    const value = row.value;
    console.log("value == ", value);
    setSelectedRecord(value);
    viewSelected(row);
  }
  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row)
    setSelectedRecord(row.value);
  }

  const deleteEmployee = async () => {
    props.setGlobalLoader(true);
    const client = await siteEmployeeRemove(selectedRecord.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: 'success', summary: 'Employee Deleted Successfully', life: 3000 });
  };

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => deleteEmployee()
    });
  }


  const changeStatusFunc = async (status: boolean) => {
    props.setGlobalLoader(true);
    const client = await siteEmployeeUpdate({ "active": status }, selectedRecord.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: 'success', summary: status ? 'Employee Activated Successfully' : 'Employee Deactivated Successfully', life: 3000 });
  }
  const disableConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to deactivate employee?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => changeStatusFunc(false)
    });
  }
  const activateConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to activate employee?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => changeStatusFunc(true)
    });
  }

  const viewSelected = (row: any) => {
    setVisible(true);
  }

  const contextItems = () => {
    let objArray = [
      { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: viewSelected },
    ];
    if (selectedRecord?.active) {
      objArray.push({ label: 'Deactivate', icon: 'pi pi-fw pi-times-circle', command: disableConfirm })
    } else {
      objArray.push({ label: 'Activate', icon: 'pi pi-fw pi-check-circle', command: activateConfirm })
    }
    objArray.push({ label: 'Delete', icon: 'pi pi-fw pi-trash', command: deleteConfirm });
    return objArray;
  }

  const columns: GenericTableColumns[] = [
    {
      field: 'name',
      header: 'Site',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'active',
      header: 'Active',
      type: GenericTableColumTypes.Boolean,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'appointment_list',
      header: 'Appointment',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'compliance_status',
      header: 'Compliance Status',
      type: GenericTableColumTypes.Boolean,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [{
          label: '',
          value: ''
        }]
      }
    }
  ];


  return (
    <React.Fragment>

      <GenericTableView reload={reload} baseFilters={baseFilter} queryParams={{ employeeId: props.employee.id || '' }}
                        url={url} columns={columns} contextItems={contextItems} addButton={addButton}
                        itemSelect={itemSelected} contextItemSelected={contextItemSelected} />

      <Dialog header={selectedRecord?.id ? "Update Site Appointment" : "Add Site & Appointment"} visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)}>
        <EmployeeSiteAdd setGlobalLoading={props.setGlobalLoader} record={selectedRecord} setReload={setReload} reload={reload} setVisible={setVisible} toast={toast} session={props.session} employee={props.employee.id || ''} />
      </Dialog>

      {/*There is already one on the parent page, this makes two dialogs popup when want to open one*/}
      {/*<ConfirmDialog />*/}

      <Toast ref={toast} />


    </React.Fragment>
  );
}